import { render, staticRenderFns } from "./MedRecordUpdateValueIcdType.vue?vue&type=template&id=08a30c9c"
import script from "./MedRecordUpdateValueIcdType.vue?vue&type=script&lang=js"
export * from "./MedRecordUpdateValueIcdType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports